export function openExternalUrl(url: string) {
  const u = (url || "").trim();
  if (!u) return;

  // allow only http(s)
  if (!/^https?:\/\//i.test(u)) return;

  try {
    window.open(u, "_blank", "noopener,noreferrer");
  } catch {
    // fallback
    window.location.href = u;
  }
}
